import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Icon, { NAMES } from '@ifit/react-icons';

import { solidWhite } from '../../theme/colors';

import pfLogo from './img/pf-logo-full.png';
import './index.css';

PFStatus.propTypes = {
  mergedAccount: PropTypes.bool,
  done: PropTypes.func,
  error: PropTypes.shape({
    message: PropTypes.string,
    action: PropTypes.func,
    buttonText: PropTypes.string,
  }),
  openTermsOfUse: PropTypes.func,
  openPrivacyPolicy: PropTypes.func,
  acceptToS: PropTypes.func,
};

const planetFitness = '<span>Planet Fitness</span>';

export default function PFStatus(props) {
  const {
    done,
    error,
    mergedAccount,
    openTermsOfUse,
    openPrivacyPolicy,
    acceptToS,
  } = props;

  const [userConsents, setUserConsents] = useState(false);

  function toggleConsent(e) {
    if (e.target.tagName.toLowerCase() === 'a') return;
    setUserConsents(!userConsents);
  }

  const accept = async () => {
    await acceptToS();
    done();
  };

  let msg = `Get moving with an awesome selection of iFit workouts, an exclusive perk for ${planetFitness} members!`;

  if (mergedAccount) {
    msg = `It looks like you‘re already a member of iFit! Your ${planetFitness} and iFit accounts have been automatically merged.`;
  }

  if (error) {
    msg = error.message;
  }

  return (
    <section className="pf-success">
      <div className="page-container">
        <img src={ pfLogo } className="pf-logo" alt="Planet Fitness" />
        <h1>{ !error ? 'Welcome!' : 'Oh, no!' }</h1>
        <p
          className="message"
          dangerouslySetInnerHTML={{ __html: msg }}
        />
        {!error &&
          <>
          <label htmlFor="user-consents" className="agreements" onClick={ toggleConsent }>
            <Icon
              className="consent-checkbox"
              name={ userConsents ? NAMES.LINE_CHECKBOX_CHECKED : NAMES.LINE_CHECKBOX }
              color={ solidWhite }
              size={ 20 }
              unitSize="px"
            />
            I have read and agree to iFit's <a onClick={ openTermsOfUse }>Terms of Use</a> and <a onClick={ openPrivacyPolicy }>Privacy Policy</a>.
          </label>
          <input type="checkbox" defaultChecked={ userConsents } name="user-consents" id="user-consents" />
          </>
        }
        <div>
          <button
            className="success-button pf-button"
            onClick={ error ? error.action : accept }
            disabled={ !error && !userConsents }
          >
            { error ? error.buttonText : 'Start now!' }
          </button>
        </div>
      </div>
    </section>);
}
